import LoadDetailsSide from './styled';

export default LoadDetailsSide;
